<template>
    <v-card class="!rounded-xl !flex" dark>
        <v-avatar size="90" class="!rounded-tl-xl !rounded-bl-xl !rounded-none">
            <v-img :src="getSpotifySong.track.album.images[0].url" v-if="getSpotifySong"></v-img>
            <v-img :src="require(`@/assets/fav_icon/android-chrome-512x512.png`)" v-else></v-img>
        </v-avatar>

        <div
            class="p-5 flex justify-between align-items-center before:absolute before:bg-gradient-to-r before:from-transparent before:to-green-500 before:rounded-md before:left-0 before:bottom-0 relative before:w-2/3 before:h-[3px]">
            <div class="flex flex-col gap-2" v-if="getSpotifySong">
                <h3 class="text-gray-300 uppercase text-sm font-Inter font-medium">{{ getSpotifySong.track.artists[0].name
                }}
                </h3>
                <h3 class="text-green-500 font-Inter font-medium capitalize text-sm">{{ getSpotifySong.track.name }}</h3>
            </div>
            <v-btn text v-else-if="!auth" class="!text-green-500 !font-Inter !font-medium !capitalize !text-sm sm:!p-2 !p-0"
                @click="spotifyShowFn">
                Click Here to Sign In
            </v-btn>
            <v-btn text v-else class="!text-green-500 !font-Inter !font-medium !capitalize !text-sm !p-2"
                @click="spotifyShowFn">
                Open Spotify
            </v-btn>
            <v-icon color="green" @click="spotifyShowFn">
                mdi-spotify
            </v-icon>
        </div>
       
    </v-card>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        spotifyShowFn() {
            if (!this.$store.getters.isPremium) {
                this.openSubscribeToPremiumDialog()
            }else{
                this.$store.dispatch('setMiniPlayerVisibility')
            }
        },
        setUserProfile() {
      this.premiumDialog = false,
        this.$store.dispatch("premium")
    },
    },
    computed: {
        auth() {
            return this.$store.getters.SpotifyAccessToken;
        },
        getSpotifySong() {
            return this.$store.getters.SpotifyCurrentSong
        }
    }
}
</script>
<style scoped>
.straight_color {
    /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
    background: rgb(177, 145, 65);
    background: linear-gradient(345deg,
        rgb(97 69 0) 0%,
        rgba(202, 174, 112, 1) 53%,
        rgb(90 64 0 / 97%) 100%);
  }
  
  .lesbian_color {
    background: rgb(126, 0, 157);
    background: linear-gradient(208deg,
        rgba(126, 0, 157, 0.9416141456582633) 2%,
        rgba(161, 51, 246, 1) 45%,
        rgba(157, 0, 176, 0.9668242296918768) 96%);
  }
  
  .gay_color {
    background: rgb(0, 240, 255);
    background: linear-gradient(39deg,
        rgba(0, 240, 255, 1) 0%,
        rgba(0, 156, 255, 1) 100%);
  }
</style>